import React, { useEffect, useState } from "react";
import {
  get_candidates_list,
  admin_candidates_employed_list,
  admin_candidates_inactive_list,
  admin_candidates_deactivated_list,
  send_bulk_emails,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import TextEditer from "../../../components/inputs/texteditor";
import CustomTable from "../../../components/table/table";
import "./view.css";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "0", label: "Pending" },
  { value: "1", label: "Submitted" },
  { value: "2", label: "Approved" },
  { value: "3", label: "Reverted to user" },
  { value: "4", label: "Reverted to admin" },
  { value: "5", label: "Rejected" },
];

const getStatusInfo = (status, id) => {
  if (id === "employed") {
    const m = {
      0: { label: "Pending", class: "pending" }, 1: { label: "Submitted", class: "info" },
      2: { label: "Approved", class: "successs" }, 3: { label: "Joined Successfully", class: "successs" },
      4: { label: "Payment Done", class: "successs" }, 5: { label: "Rejected", class: "danger" },
    };
    return m[status] || { label: "Unknown", class: "secondary" };
  }
  const m = {
    0: { label: "Pending", class: "pending" }, 1: { label: "Submitted", class: "info" },
    2: { label: "Approved", class: "successs" }, 3: { label: "Reverted to user", class: "danger" },
    4: { label: "Reverted to admin", class: "danger" }, 5: { label: "Rejected", class: "danger" },
    9: { label: "Deactivated", class: "danger" },
  };
  return m[status] || { label: "Unknown", class: "secondary" };
};

const EMPTY_EMAIL = { subject: "", body_html: "", metadata: { campaign: "", priority: "normal" } };

export default function BulkEmail(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [emailFormData, setEmailFormData] = useState(EMPTY_EMAIL);

  // Pagination
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  // Filter
  const [status, setStatus] = useState("");
  const [showFilters, setShowFilters] = useState(true);

  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const { id } = useParams();

  const handleListData = () => {
    setIsActive(true);
    const pg = page;
    const pp = perPage === "all" ? 99999 : Number(perPage);

    const onSuccess = (res) => {
      const rawData = (res?.data || []).map((item, i) => ({
        ...item,
        slno: (pg - 1) * pp + i + 1,
      }));
      setData(rawData);
      setTotalPages(res?.last_page || 1);
      setTotalRecords(res?.total || 0);
      setIsActive(false);
    };
    const onError = () => { setData([]); setIsActive(false); };

    if (id === "employed") admin_candidates_employed_list(adminType, pg, pp).then(onSuccess).catch(onError);
    else if (id === "inactive") admin_candidates_inactive_list(adminType, pg, pp).then(onSuccess).catch(onError);
    else if (id === "optedout") admin_candidates_deactivated_list(adminType, pg, pp).then(onSuccess).catch(onError);
    else get_candidates_list(adminType, pg, pp, { status }).then(onSuccess).catch(onError);
  };

  useEffect(() => { handleListData(); }, [page, perPage, status, id]); // eslint-disable-line
  useEffect(() => { setPage(1); setStatus(""); setSelectedRows([]); }, [id]);

  const handleChangeStatus = (e) => { setStatus(e.target.value); setPage(1); };
  const handlePerPageChange = (e) => { setPerPage(e.target.value); setPage(1); };

  const pageIds = data.map(i => i.id);
  const allPageSelected = pageIds.length > 0 && pageIds.every(pid => selectedRows.includes(pid));

  const handleSelectPage = () => {
    if (allPageSelected) {
      setSelectedRows(prev => prev.filter(id => !pageIds.includes(id)));
    } else {
      setSelectedRows(prev => [...new Set([...prev, ...pageIds])]);
    }
  };

  const handleRowSelect = (rowId) => {
    setSelectedRows(prev =>
      prev.includes(rowId) ? prev.filter(i => i !== rowId) : [...prev, rowId]
    );
  };

  const snackbarClose = (flag) => {
    setSnackMessage(""); setIsSnackError(false); setSnackOpen(false);
    if (!flag) handleListData();
  };

  const handleEmailFormChange = (field, value) => {
    if (field.includes(".")) {
      const [parent, child] = field.split(".");
      setEmailFormData(prev => ({ ...prev, [parent]: { ...prev[parent], [child]: value } }));
    } else {
      setEmailFormData(prev => ({ ...prev, [field]: value }));
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.some(f => f.size > 5 * 1024 * 1024)) {
      setSnackMessage("File size must be less than 5 MB");
      setIsSnackError(true); setSnackOpen(true);
      e.target.value = "";
      return;
    }
    setSelectedFiles(files);
  };

  const handleEmailSubmit = async () => {
    const formData = new FormData();
    formData.append("user_category", "job_seekers");
    selectedRows.forEach(uid => formData.append("user_ids[]", uid));
    formData.append("subject", emailFormData.subject);
    formData.append("body_html", emailFormData.body_html);
    formData.append("metadata[campaign]", emailFormData.metadata.campaign);
    formData.append("metadata[priority]", emailFormData.metadata.priority);
    selectedFiles.forEach(f => formData.append("documents[]", f));

    try {
      setIsActive(true);
      await send_bulk_emails(formData);
      setSnackMessage(`Email sent to ${selectedRows.length} job seekers successfully!`);
      setIsSnackError(false); setSnackOpen(true);
      setShowEmailPopup(false); setSelectedRows([]);
      setEmailFormData(EMPTY_EMAIL); setSelectedFiles([]);
    } catch (error) {
      setSnackMessage(error.message || "Failed to send emails.");
      setIsSnackError(true); setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  const handleEmailCancel = () => {
    setShowEmailPopup(false);
    setEmailFormData(EMPTY_EMAIL);
    setSelectedFiles([]);
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);
    if (start > 1) {
      pages.push(<button key={1} className="btn btn-outline-primary" style={{ fontSize: "13px" }} onClick={() => setPage(1)}>1</button>);
      if (start > 2) pages.push(<span key="sd" className="px-1 text-primary">...</span>);
    }
    for (let i = start; i <= end; i++) {
      pages.push(
        <button key={i} className={`btn ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`} style={{ fontSize: "13px" }} onClick={() => setPage(i)}>{i}</button>
      );
    }
    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="ed" className="px-1 text-primary">...</span>);
      pages.push(<button key={totalPages} className="btn btn-outline-primary" style={{ fontSize: "13px" }} onClick={() => setPage(totalPages)}>{totalPages}</button>);
    }
    return pages;
  };

  const pageTitle = id === "registry" ? "Job Seeker Registry"
    : id === "employed" ? "Employed through KSPACE"
      : id === "inactive" ? "Inactive Registrations"
        : id === "optedout" ? "Opted-Out"
          : "Job Seeker Data";

  const showStatusFilter = id === "registry" || !id;

  return (
    <>
      <div className="container-fluid mt-4">
        <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />
        <Loader open={isActive} />

        <div className="card shadow-sm">
          {/* ── Card Header ── */}
          <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
            <h5 className="mb-0"><b>Bulk Email — {pageTitle}</b></h5>
            <div className="d-flex gap-2">
              <button className="btn-back-header d-flex align-items-center gap-1"
                onClick={() => props.history.push(`/candidates-list/${id ?? "registry"}`)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back
              </button>
              <button className="btn btn-secondary btn-sm" onClick={handleSelectPage}>
                {allPageSelected ? "Deselect All" : "Select All"}
              </button>
              {selectedRows.length > 0 && (
                <button className="btn btn-outline-secondary btn-sm" onClick={() => setSelectedRows([])}>
                  Clear ({selectedRows.length})
                </button>
              )}
              {selectedRows.length > 0 && (
                <button className="btn btn-primary btn-sm search-style border-0 text-white" onClick={() => setShowEmailPopup(true)}>
                  Send Email ({selectedRows.length})
                </button>
              )}
              {showStatusFilter && (
                <button className={`filter-icon-btn ${showFilters ? "active" : ""}`}
                  onClick={() => setShowFilters(!showFilters)} title="Toggle Filters">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                  </svg>
                </button>
              )}
            </div>
          </div>

          <div className="card-body pt-0">
            {/* ── Collapsible Filter Panel ── */}
            {showStatusFilter && (
              <div className={`filter-container ${showFilters ? "show" : ""}`}>
                <div className="row align-items-end">
                  <div className="col-md-4">
                    <label className="form-label small">Status</label>
                    <select className="form-control filter-select" value={status} onChange={handleChangeStatus}>
                      {STATUS_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 d-flex gap-2 align-items-end">
                    <button className="filter-action-btn" title="Reset Filters"
                      onClick={() => { setStatus(""); setPage(1); }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path>
                      </svg>
                    </button>
                    <button className="filter-action-btn close-btn" title="Close Filters"
                      onClick={() => setShowFilters(false)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ── Pagination Info + Controls ── */}
            <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded border" style={{ fontSize: "14px" }}>
              <div className="d-flex align-items-center gap-3">
                <span className="text-muted fw-semibold">
                  <span className="text-dark fw-bold">{selectedRows.length}</span> selected &bull; showing <span className="text-dark fw-bold">{data.length}</span> of <span className="text-dark fw-bold">{totalRecords}</span>
                </span>
                <span className="badge bg-primary" style={{ fontSize: "13px", padding: "6px 12px" }}>
                  Page {page} of {totalPages}
                </span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <label className="text-muted fw-semibold mb-0" style={{ fontSize: "13px" }}>Rows per page:</label>
                  <select className="form-select form-select-sm" value={perPage} onChange={handlePerPageChange} style={{ fontSize: "13px", height: "36px", width: "80px" }}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="all">All</option>
                  </select>
                </div>
                <div className="btn-group">
                  <button className="btn btn-outline-primary" disabled={page === 1} onClick={() => setPage(p => p - 1)} style={{ fontSize: "13px" }}>Prev</button>
                  {renderPagination()}
                  <button className="btn btn-outline-primary" disabled={page === totalPages} onClick={() => setPage(p => p + 1)} style={{ fontSize: "13px" }}>Next</button>
                </div>
              </div>
            </div>

            {/* ── Data Table ── */}
            <CustomTable
              {...props}
              paging={false}
              columns={[
                {
                  title: "Select", field: "select",
                  render: (row) => (
                    <input type="checkbox" checked={selectedRows.includes(row.id)}
                      onChange={(e) => { e.stopPropagation(); handleRowSelect(row.id); }}
                      style={{ cursor: "pointer" }} />
                  ),
                },
                { title: "Name", field: "name" },
                { title: "Email", field: "email" },
                { title: "Phone Number", field: "contact" },
                {
                  title: "Updated at", field: "updated_at",
                  render: (row) => row.updated_at ? moment(row.updated_at).format("DD-MM-YYYY hh:mm A") : "--",
                },
                {
                  title: "Status", field: "status",
                  render: (row) => {
                    const si = getStatusInfo(row.status, id);
                    return (
                      <span className={`status-badge ${si.class}`}>
                        <span className="status-label">{si.label}</span>
                      </span>
                    );
                  },
                },
              ]}
              data={data}
              options={{ search: false, selection: false, exportButton: false }}
            />
          </div>
        </div>
      </div>

      {/* ── Email Compose Modal ── */}
      {showEmailPopup && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={{ backgroundColor: "white", padding: "24px", borderRadius: "8px", width: "100%", maxWidth: "900px", maxHeight: "85vh", overflowY: "auto" }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="mb-0">Compose Email</h5>
              <button type="button" onClick={handleEmailCancel} style={{ background: "none", border: "none", fontSize: "22px", cursor: "pointer", color: "#6c757d" }}>×</button>
            </div>

            <div className="mb-3">
              <small className="text-muted">To: <strong>{selectedRows.length} job seekers</strong> selected</small>
            </div>

            <div className="mb-3">
              <label className="form-label">Subject <span className="text-danger">*</span></label>
              <input type="text" className="form-control" value={emailFormData.subject}
                onChange={e => handleEmailFormChange("subject", e.target.value)} placeholder="Enter email subject" />
            </div>

            <div className="mb-3">
              <TextEditer
                label={<>Message <span className="text-danger">*</span></>}
                value={emailFormData.body_html}
                onChange={value => handleEmailFormChange("body_html", value)}
                required />
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Campaign</label>
                <input type="text" className="form-control" value={emailFormData.metadata.campaign}
                  onChange={e => handleEmailFormChange("metadata.campaign", e.target.value)} placeholder="Campaign name" />
              </div>
              <div className="col-md-6">
                <label className="form-label">Priority</label>
                <select className="form-select" value={emailFormData.metadata.priority}
                  onChange={e => handleEmailFormChange("metadata.priority", e.target.value)}>
                  <option value="normal">Normal</option>
                  <option value="high">High</option>
                  <option value="low">Low</option>
                </select>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Attachments</label>
              <input type="file" className="form-control" multiple onChange={handleFileChange} />
              {selectedFiles.map((f, i) => (
                <div key={i} className="d-flex justify-content-between align-items-center mt-1">
                  <small className="text-primary">{f.name} ({(f.size / 1024).toFixed(2)} KB)</small>
                  <button type="button" className="btn btn-sm btn-outline-danger"
                    onClick={() => setSelectedFiles(prev => prev.filter((_, idx) => idx !== i))}>Remove</button>
                </div>
              ))}
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
              <button type="button" className="btn btn-secondary" style={{ minWidth: 120 }} onClick={handleEmailCancel}>Cancel</button>
              <button type="button" className="btn btn-primary" style={{ minWidth: 120 }}
                onClick={handleEmailSubmit} disabled={!emailFormData.subject || !emailFormData.body_html}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
